import { ActionReducerMap } from '@ngrx/store';
import { painterReducer } from './painters/painter.reducer';
import { spcializationReducer } from './specializations/specializations.reducer';
import { userTypeReducer } from './userTypes/userTypes.reducer';
import { workAreaReducer } from './workarea/workArea.reducer';
import { colorReducer } from './colors/colors.reducer';
import { permissionsReducer } from './permissions/permissions.reducer';
import { currentUserReducer } from './currentUser/currentUser.reducer';
import { businessUserReducer } from './businessUser/businessUser.reducer';
import { adminTypeReducer } from './adminType/adminType.reducer';
import { cityReducer } from './cities/cities.reducer';
import { pendingCountsReducer } from './pendingCounts/pendingCounts.reducer';
import { dictionaryReducer } from './dictionary/dictionary.reducer';
export interface AppState {
  painters: ReturnType<typeof painterReducer>;
  specializations: ReturnType<typeof spcializationReducer>;
  userTypes: ReturnType<typeof userTypeReducer>;
  workArea: ReturnType<typeof workAreaReducer>;
  colors: ReturnType<typeof colorReducer>;
  permissions: ReturnType<typeof permissionsReducer>;
  currentUser: ReturnType<typeof currentUserReducer>;
  businessUser: ReturnType<typeof businessUserReducer>;
  adminType: ReturnType<typeof adminTypeReducer>;
  cities: ReturnType<typeof cityReducer>;
  pendingCounts: ReturnType<typeof pendingCountsReducer>;
  dictionary: ReturnType<typeof dictionaryReducer>;
}

export const reducers: ActionReducerMap<AppState> = {
  painters: painterReducer,
  specializations: spcializationReducer,
  userTypes: userTypeReducer,
  workArea: workAreaReducer,
  colors: colorReducer,
  permissions: permissionsReducer,
  currentUser: currentUserReducer,
  businessUser: businessUserReducer,
  adminType: adminTypeReducer,
  cities: cityReducer,
  pendingCounts: pendingCountsReducer,
  dictionary: dictionaryReducer,
};
